// extracted by mini-css-extract-plugin
module.exports = {"list":"award-list_list__YG90D","logo":"award-list_logo__ib83c","heading":"award-list_heading__TQc_P"};